import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  quote: 'Organicé todo el mes en una tarde. Publiqué 4 Reels el primer día.',
  author: 'Marcela G., Córdoba',
  niche: 'Cosméticos naturales'
}, {
  initials: 'LP',
  quote: 'El Tomo 2 me dio las palabras exactas para detener el scroll. Vale cada peso.',
  author: 'Laura P., Rosario',
  niche: 'Bijoutería'
}, {
  initials: 'RM',
  quote: 'El calendario de 30 días es un antes y un después. Publico todos los días sin pensar de qué hablar.',
  author: 'Roberto M., Buenos Aires',
  niche: 'Indumentaria'
}];
export function SocialProofBar() {
  return <section className="w-full py-10 px-4 bg-base border-y border-alt" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 mb-12 text-lg md:text-xl font-bold text-text-main" data-id="element-218">
          <span data-id="element-219">+500 emprendedores</span>
          <span className="hidden md:inline text-primary" data-id="element-220">•</span>
          <span data-id="element-221">6 Tomos</span>
          <span className="hidden md:inline text-primary" data-id="element-222">•</span>
          <span data-id="element-223">6 Bonos</span>
          <span className="hidden md:inline text-primary" data-id="element-224">•</span>
          <span className="flex items-center gap-1" data-id="element-225">
            4.9/5 <span className="text-primary" data-id="element-226">⭐</span>
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-227">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-alt border border-detail/20 rounded-2xl p-6 flex flex-col h-full" data-id="element-228">
              <div className="flex items-center gap-4 mb-4" data-id="element-229">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl border border-primary/30" data-id="element-230">
                  {t.initials}
                </div>
                <div className="flex text-primary text-sm" data-id="element-231">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-text-main italic mb-6 flex-grow" data-id="element-232">
                "{t.quote}"
              </p>
              <div data-id="element-233">
                <p className="font-bold text-sm text-text-main" data-id="element-234">{t.author}</p>
                <p className="text-xs text-text-muted mt-1" data-id="element-235">{t.niche}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}